// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {filter, includes, map} from 'lodash';
import classnames from 'classnames';

// Components
import Error from '../core/error';
import MultiSelect from '../core/multi-select';

// Containers
import withAuth from '../../containers/with-auth';
import withSearch from '../../containers/with-search';

function ServiceSelect({ className, error, fetched, isAdmin, label = 'Services', multi = true, name = 'service.serviceName', scope, searchData, validate }) {
  const getClass = () => classnames(
      {
        'service-select': true,
      },
      className
    );

  const getOptions = (services) => map(services, (value) => ({
      value: value.toLowerCase(),
      label: value.split('_').join(' '),
    }));

  const authorizedServices = () => (isAdmin && isAdmin()
            ? searchData
            : filter(searchData, (service) => includes(scope, `${service.toLowerCase()}_read`)) || []);

  const renderSelect = () => {
    const services = authorizedServices();
    let content = null;

    if (!error) {
      content = (
                <MultiSelect
                    disabled={!fetched || !services.length}
                    label={label}
                    multi={multi}
                    name={name}
                    operator="=in="
                    options={getOptions(services)}
                    placeholder="Filter by Service"
                    validate={validate}
                />
      );
    }

    return content;
  };

  return (
        <div className={getClass()}>
            <Error error={error} />
            {renderSelect()}
        </div>
  );
}

ServiceSelect.propTypes = {
    className: PropTypes.string,
    error: PropTypes.string,
    fetched: PropTypes.bool.isRequired,
    isAdmin: PropTypes.func.isRequired,
    label: PropTypes.string,
    multi: PropTypes.bool,
    name: PropTypes.string,
    scope: PropTypes.array.isRequired,
    searchData: PropTypes.array,
    validate: PropTypes.array,
};

export default withSearch(withAuth(ServiceSelect), 'servicesSelect');
